import React, { useState, useEffect } from 'react';
import Layout from '../components/layout';
import { graphql } from 'gatsby';
import { Link } from 'gatsby';
import { MethodologySection } from '../components/home/MethodologySection';
import { RankingSection } from '../components/home/RankingSection';
import { ExpertsSection } from '../components/ExpertsSection';
import { useMediaQuery } from '../helpers/useMediaQuery';
import TableComponent from '../components/Table';
import columnList from '../components/Table/columns';
import GlobeComponent from '../components/HomeGlobe';

const getColumns = (callback, isPageWide) => () => {
	let columns = columnList['default'] || [];
	if (!isPageWide) {
		columns = columns.filter((col) => col.desktopOnly !== true);
	}
	callback(columns);
};

const introConfig = {
	className: '--home',
	heading: 'Where Can Your Passport Take You?',
	description:
		'Discover the world’s best passports in 2021. We rank the top global citizenships of today, using a unique set of criteria to determine a passport’s power.',
	DescriptionComponent: () => (
		<div className="mt-12 mb-16">
			<h2>The True Value of a Passport</h2>
			<p className="mt-8">
				What makes a global citizen seek second citizenship? Admittedly,
				it’s not just about the number of countries a passport
				facilitates visa-free access to. Factors like ease of doing
				business, quality of life, and investment opportunities are all
				big draws for individuals looking to uproot their lives and
				acquire a second passport. Hence, our Global Passport Index came
				to fruition.
			</p>
			<Link to="/the-full-story/" className="btn btn__primary mt-8">
				READ THE FULL STORY
			</Link>
		</div>
	),
	ImageComponent: () => <GlobeComponent />,
};

export default function Home({ data }) {
	const [columns, setColumns] = useState([]);
	const isPageWide = useMediaQuery('(min-width: 1200px)');
	useEffect(getColumns(setColumns, isPageWide), [isPageWide]);
	const rankingList = data.allMainIndex.edges.map(({ node }) => node);
	const quality = data.quality.nodes;
	const mobility = data.mobility.nodes;
	const investment = data.investment.nodes;
	return (
		<Layout introConfig={introConfig}>
			<div className="container section-wrapper">
				<h2 className="section-title">
					The World’s Most Powerful Passports in 2021
				</h2>
				<div className="section-content xl:mt-8">
					<TableComponent columns={columns} data={rankingList} />
					<Link
						to="/global-passport-index"
						className="btn btn__primary mt-8"
					>
						View full ranking
					</Link>
				</div>
			</div>
			<MethodologySection />
			<RankingSection
				quality={quality}
				mobility={mobility}
				investment={investment}
			/>
			<ExpertsSection />
		</Layout>
	);
}

export const query = graphql`
	query {
		allMainIndex(limit: 10) {
			edges {
				node {
					id
					iso2c
					iso_name_en
					mobilty_rank
					invest_rank
					global_passport_rank
					eqol_rank
				}
			}
		}

		quality: allMainIndex(limit: 3, sort: { fields: eqol_rank }) {
			nodes {
				iso2c
				eqol_rank
				global_passport_rank
			}
		}
		mobility: allMobilityIndex(sort: { fields: mobility_rank }, limit: 3) {
			nodes {
				mobility_rank
				iso2c
				global_passport_rank
			}
		}
		investment: allInvestIndex(limit: 3, sort: { fields: invest_rank }) {
			nodes {
				invest_rank
				iso2c
				global_passport_rank
			}
		}
	}
`;
